import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import esTranslations from '../utils/locale/es/translation.json';
import caTranslations from '../utils/locale/ca/translation.json';
import gaTranslations from '../utils/locale/ga/translation.json';
import euTranslations from '../utils/locale/eu/translation.json';

const resources = {
  es: { translation: esTranslations },
  va: { translation: caTranslations },
  ca: { translation: caTranslations },
  ga: { translation: gaTranslations },
  eu: { translation: euTranslations },
  ar: { translation: esTranslations }
};

const defaultLng = 'es'
export const initialize = () =>
  i18n.use(initReactI18next).init({
    resources,
    lng: defaultLng,
    fallbackLng: defaultLng,
    interpolation: {
      escapeValue: false
    }
  });

initialize();

export default i18n;